import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7fb2162c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "table is-fullwidth is-hoverable list-table similar-analysis-list" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", null, null, -1))

import { Delete, View } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox } from 'element-plus';
import { useI18n } from 'vue-i18n';
import { useRouter } from 'vue-router';

import AnalysisStatusBadge from '@/components/AnalysisStatusBadge.vue';
import MemberAvatar from '@/components/MemberAvatar.vue';
import { canDeleteAnalysis, canViewAnalysis } from '@/helpers/permission';
import { useSimilarAnalysesStore } from '@/stores/similar-analyses.store';


export default /*#__PURE__*/_defineComponent({
  __name: 'SimilarAnalysesList',
  emits: ['delete'],
  setup(__props, { emit }) {

const { t } = useI18n();
const router = useRouter();
const similarAnalysesStore = useSimilarAnalysesStore();



const formatDate = (value: string): string =>
    new Date(value).toLocaleDateString(undefined, {
        year: 'numeric',
        month: 'numeric',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
    });

// Owns the delete action (confirm + store + toast); the parent that owns the list
// data reacts to the emit to update its own view.
const deleteAnalysis = async (analysisId: string): Promise<void> => {
    try {
        await ElMessageBox.confirm(t('analysis.deleteConfirmMessage'), t('analysis.deleteConfirmTitle'), {
            type: 'warning',
            confirmButtonText: t('common.yes'),
            cancelButtonText: t('common.no'),
        });
        try {
            await similarAnalysesStore.deleteAnalysis(analysisId);
            ElMessage.success(t('analysis.deleteConfirmed'));
            emit('delete', analysisId);
        } catch (error) {
            const { message } = error as { message: string };
            ElMessage.error(message);
        }
    } catch (error) {
        ElMessage.info(t('analysis.deleteCanceled'));
    }
};

return (_ctx: any,_cache: any) => {
  const _component_el_link = _resolveComponent("el-link")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _createElementVNode("thead", null, [
      _createElementVNode("tr", null, [
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('listAnalyses.analyzedBy')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('listAnalyses.status')), 1),
        _createElementVNode("th", null, _toDisplayString(_ctx.$t('listAnalyses.lastModifiedDate')), 1),
        _hoisted_2
      ])
    ]),
    _createElementVNode("tbody", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(similarAnalysesStore).similar, (analysis) => {
        return (_openBlock(), _createElementBlock("tr", {
          key: analysis.analysisId
        }, [
          _createElementVNode("td", null, [
            (analysis.owner)
              ? (_openBlock(), _createBlock(MemberAvatar, {
                  key: 0,
                  member: analysis.owner
                }, null, 8, ["member"]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("td", null, [
            _createVNode(AnalysisStatusBadge, {
              status: analysis.status
            }, null, 8, ["status"])
          ]),
          _createElementVNode("td", null, _toDisplayString(formatDate(analysis.createdAt)), 1),
          _createElementVNode("td", null, [
            (_unref(canViewAnalysis)(analysis))
              ? (_openBlock(), _createBlock(_component_el_link, {
                  key: 0,
                  icon: _unref(View),
                  underline: false,
                  target: "_blank",
                  href: 
                            _unref(router).resolve({
                                name: 'analysis-form',
                                params: { analysisId: analysis.analysisId },
                            }).href
                        
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("  " + _toDisplayString(_ctx.$t('common.view')), 1)
                  ]),
                  _: 2
                }, 1032, ["icon", "href"]))
              : _createCommentVNode("", true),
            _createTextVNode("   "),
            (_unref(canDeleteAnalysis)(analysis))
              ? (_openBlock(), _createBlock(_component_el_button, {
                  key: 1,
                  circle: "",
                  plain: "",
                  icon: _unref(Delete),
                  onClick: ($event: any) => (deleteAnalysis(analysis.analysisId))
                }, null, 8, ["icon", "onClick"]))
              : _createCommentVNode("", true)
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})